import { call, put, takeLatest } from "redux-saga/effects";
import { CourierTypeReportActionTypes } from "./actionTypes";
import {
    getCourierTypeReportListSuccess,
    getCourierTypeReportListError,
} from "./actions";
import { API } from "src/util/api";

function* getCourierTypeReportListAsync(action: any) {
    try {
        const response: Promise<any> = yield call(API.getCourierTypeReportAPI, {
            ...action.lazyState,
        });
        yield put(getCourierTypeReportListSuccess(response));
    } catch (error) {
        yield put(getCourierTypeReportListError(error));
    }
}

function* CourierTypeReportSaga() {
    yield takeLatest(
        CourierTypeReportActionTypes.GET_COURIER_TYPE_REPORT_LIST,
        getCourierTypeReportListAsync
    );
}

export default CourierTypeReportSaga;
